export const JIRA_BOARD_PROJECT_Name = {
  OCI: "oci",
  AZURE: "azure",
  AWS: "aws",
  FINOPS: "cloudfinops"
};
export const JIRA_BOARD_PROJECT_IDS = {
  AWS: "11494",
  OCI: "11498",
  AZURE: "11496",
  FINOPS: "11500"
};

export const POLICY_EXCEPTIONS = [
  { value: 'azure_MandatoryTagPolicyForm', viewValue: 'Mandatory Tag Policy' },
  { value: 'azure_RestrictPublicAccessStorageAccountForm', viewValue: 'Restrict Public Access Storage Account' },
];

export const AWS_NETWORK_SIZE = [
  { value: 'Small (500 IPs)', viewValue: 'Small (500 IPs)' },
  { value: 'Medium 1000 IPs', viewValue: 'Medium 1000 IPs' },
  { value: 'Large (5000 IPs)', viewValue: 'Large (5000 IPs)' }
]

export const AWS_Locations = [
  { 'name': 'USA' },
  { 'name': 'APAC' },
  { 'name': 'EMEA' },
  { 'name': 'CN' }
]

export const AWS_Envirnoment = [
  { 'name': 'DEV' },
  { 'name': 'STG' },
  { 'name': 'PROD' }
]

export const AWS_IntendeOptions = [
  { name: 'SSO Console Access' },
  { name: 'Application Authentication' }
]

export const OCI_Envirnoment = [
  { 'name': 'Alpha/Beta' },
  { 'name': 'DR' },
  { 'name': 'DEV' },
  { 'name': 'STG' },
  { 'name': 'PROD' }
]

export const OCI_Domains= [
  { name: 'idcsdev' },
  { name: 'hcm_dev_domain' },
  { name: 'idcstst' },
  { name: 'idcsbeta' },
  { name: 'idcslab' },
  { name: 'OracleIdentityCloudService' },
  { name: 'OracleIdentityCloudServicePrd' },
  { name: 'OracleIdentityCloudServiceStg' },
  { name: 'Default' },
  { name: 'OCI_Federated' }
]